import { render, staticRenderFns } from "./EditDivision.vue?vue&type=template&id=45bcde6e&scoped=true&"
import script from "./EditDivision.vue?vue&type=script&lang=js&"
export * from "./EditDivision.vue?vue&type=script&lang=js&"
import style0 from "./EditDivision.vue?vue&type=style&index=0&id=45bcde6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bcde6e",
  null
  
)

export default component.exports